module.exports = __webpack_public_path__ + "img/abercrombie.055751e.svg";